import { Component, Input } from '@angular/core';
import { MapService } from '../../../../../../shared/services/map.service';

@Component({
    selector: 'app-attachments-block',
    templateUrl: './attachments-block.component.html',
    styleUrls: ['../styles.css', './attachments-block.component.scss'],
    standalone: false
})
export class AttachmentsBlockComponent {
  @Input() pictures: any[] = [];

  constructor(
    private mapService: MapService,
  ) {
  }

  openPictures() {
    this.mapService.selectedPicturesData.next({picturesList: this.pictures});
  }
}
